import { Component } from 'react';
import { Button, Container } from 'react-bootstrap';

// Catches render errors anywhere below it so a single broken component
// shows a recovery screen instead of blanking the whole app.
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <Container className="d-flex flex-column align-items-center justify-content-center text-center min-vh-100">
        <h3 className="mb-2">Something went wrong</h3>
        <p className="text-muted mb-4">
          Please reload the page. If the problem continues, try again later.
        </p>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Container>
    );
  }
}

export default ErrorBoundary;
